import {Form, Select} from 'antd';
import {FormInstance} from 'antd/lib/form';
import _ from 'lodash';
import React, {useEffect, useState} from 'react';
import {LabelAndKey} from './types/LabelAndKey';
import {handlePaste} from "./SelectUtil";
import {apiFetchOptions} from "./selectorApi";
import {getCriterionValue} from "../../containers/CohortBuilder/criterion";

const { Option } = Select;

interface Props {
    form: FormInstance
    fieldId: string
    fieldLabel: string // label in UI
    fieldURL: string
    dependencies?: string[]
    fieldValidator?(rule: any, value: any): Promise<void>
    fieldLabelFunction(e: LabelAndKey): string
    criterion: any
}

const GenericSearchSelector = ({ fieldId, fieldLabel, fieldURL, dependencies, fieldValidator, fieldLabelFunction, criterion, form }: Props) => {

    const [optionsData, setOptionsData] = useState(new Array<LabelAndKey>())
    const [filteredOptionsData, setFilteredOptionsData] = useState(new Array<LabelAndKey>())

    useEffect(() => {
        return apiFetchOptions(fieldURL, (labelAndKeys => {
            setOptionsData(labelAndKeys);
        }))
    }, [fieldURL])

    const onSearch = _.debounce((value) => {
        setFilteredOptionsData([])
        const searchString = value.toLowerCase()
        const result = optionsData.filter(i => {
            return i.key.toLowerCase().includes(searchString) || i.label.toLowerCase().includes(searchString)
        })
        setFilteredOptionsData(result)
    }, 500)

    const resetChoices = () => {
        setFilteredOptionsData([])
    }

    const rules = () => {
        return _.isNil(fieldValidator) ? [] : [{ validator: fieldValidator }]
    }

    const options = filteredOptionsData.length === 0 ? optionsData : filteredOptionsData;

    return <Form.Item
        name={fieldId}
        label={fieldLabel}
        initialValue={getCriterionValue(criterion, fieldId)}
        rules={rules()}
        dependencies={dependencies}
    >
        <Select
            allowClear={true}
            mode="multiple"
            // style={{ width: '100%' }}
            placeholder={"Select " + fieldLabel}
            optionFilterProp="children"
            filterOption={true}
            onBlur={resetChoices}
            onSearch={onSearch}
            labelInValue={true}
            autoClearSearchValue={false}
            // @ts-ignore
            onPaste={(e: React.ClipboardEvent<HTMLTextAreaElement>) => {
                handlePaste(e, form, fieldId, fieldLabel, fieldLabelFunction, optionsData)
                return true
            }}
        >
            {options.map(i => (
                <Option value={i.key} key={i.key}>{fieldLabelFunction(i)}</Option>
            ))}
        </Select>
    </Form.Item>

}

export default GenericSearchSelector